import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';

export const useAuthErrorHandler = () => {
  const navigate = useNavigate();

  const handleAuthError = useCallback((error) => {
    // Check if error is related to authentication
    if (error.message.includes('401') || 
        error.message.includes('Unauthorized') || 
        error.message.includes('Authentication')) {
      
      // Clear tokens
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      
      // Navigate to signin
      navigate('/signin');
      
      return true; // Indicates auth error was handled
    }
    return false; // Not an auth error
  }, [navigate]);

  return handleAuthError;
};
